import { Briefcase } from "lucide-react";
import { AdminTicketReply } from "@/components/TicketReply";

const BASE = process.env.REACT_APP_BACKEND_URL;

/** Turn a ticket into a job-form draft (address/best-times parsed from on-site request descriptions). */
export function ticketToJobDraft(t) {
  const grab = (label) => (t.description.match(new RegExp(`${label}:\\s*(.*)`)) || [])[1]?.trim() || "";
  const address = grab("Address / area");
  return {
    title: t.issue_type === "On-site visit" ? `On-site visit for ${t.name}` : `${t.issue_type} — on-site`,
    area: address.split(",").slice(-2).join(",").trim() || address,
    date_window: grab("Best days & times").replace(/^—$/, ""),
    summary: (grab("Notes").replace(/^—$/, "") || t.description).slice(0, 1500),
    customer_name: t.name || "", customer_phone: t.phone || "", customer_address: address, customer_email: t.email || "",
    ticket_id: t.ticket_id, booking_id: t.booking_id || "",
  };
}

export function TicketsList({ tickets, onChanged, onPostJob }) {
  if (tickets.length === 0) return <div className="text-slate-500 text-sm">No tickets yet.</div>;
  return (
    <div className="space-y-3">
      {tickets.map((t) => (
        <div key={t.ticket_id} className="dg-card rounded-xl p-5" data-testid={`ticket-row-${t.ticket_id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="flex-1 min-w-0">
              <div className="font-mono text-xs uppercase tracking-widest text-cyan-300">{t.ticket_id}</div>
              <div className="font-display text-lg font-semibold mt-1">{t.issue_type} · <span className="text-slate-400">urgency {t.urgency}</span>{t.member_tier && <span className="dg-chip ml-2 align-middle text-[#FFD600] border-[#FFD600]/50" data-testid={`ticket-member-${t.ticket_id}`}>Member · {t.member_tier_name} · priority</span>}</div>
              <div className="text-sm text-slate-400 mt-1">{t.name} · <a href={`mailto:${t.email}`} className="dg-link">{t.email}</a>{t.phone && <> · <a href={`tel:${t.phone}`} className="dg-link">{t.phone}</a></>}{t.booking_id && <> · follow-up to booking <span className="font-mono text-cyan-300" data-testid={`ticket-booking-${t.ticket_id}`}>{t.booking_id}</span></>}</div>
              <p className="text-sm text-slate-300 mt-3 whitespace-pre-wrap">{t.description}</p>
              {t.files?.length > 0 && (
                <div className="mt-3 grid grid-cols-3 sm:grid-cols-6 gap-2">
                  {t.files.map((f) => (
                    <a key={f.storage_path} className="dg-card rounded-md p-2 text-[10px] font-mono truncate" title={f.original_filename} href={`${BASE}/api/admin/files/${f.storage_path}`} target="_blank" rel="noreferrer">
                      {f.original_filename}
                    </a>
                  ))}
                </div>
              )}
              {onPostJob && (
                <button type="button" onClick={() => onPostJob(ticketToJobDraft(t))} className="dg-btn-ghost rounded-full px-3 py-1.5 text-xs mt-3 inline-flex items-center gap-1" data-testid={`ticket-post-job-${t.ticket_id}`}>
                  <Briefcase className="w-3 h-3" /> Post as job for a partner tech
                </button>
              )}
            </div>
            <AdminTicketReply ticket={t} onDone={onChanged} />
          </div>
        </div>
      ))}
    </div>
  );
}
